import React from "react";
import { connect } from "react-redux";
import AvailabilityDonut from "../AvailabilityDonut";
import { sendPostRequest } from "../../../../../actions/app-actions";
import { getAdminBusinessId } from "../../../../../utils/authHelper";

const PieSalesChart = (props) => (
  <AvailabilityDonut
    sendPostRequest={props.sendPostRequest}
    url={`/admin/event-availability-ratio-chart/${getAdminBusinessId()}`}
    title="Event capacity"
    subtitle="Booked time vs. open slots per event"
    tooltipCode="P3F4"
    filterKey="event_id"
    filterOptions={props.events}
    filterPlaceholder="All events"
  />
);

export default connect(null, { sendPostRequest })(PieSalesChart);
